import withLoader from "../../../../../components/layouts/WithLoader"
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { useState } from "react";
import ProductionOrderService from "../../../../../services/Production/ProductionOrderService";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import DataTableStepsWorkOrder from "./DataTableStepsWorkOrder";







const WorkOrdersSteps =({startLoading,stopLoading})=>{

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [dateBegin, setDateBegin] = useState();
  const[listSteps,setListSteps]=useState();
  const[workOrder,setWorkOrder]=useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [infoAlertText, setInfoAlertText] = useState();

  const [dateEnd, setDateEnd] = useState();

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value.concat(":59"));
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value.concat(":59"));
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onGetWorkOrdersHandler=()=>{
    startLoading();
    setListSteps([])
    ProductionOrderService.getListStepsByWorkOrder(getCurrentUserId(), localStorage.getItem("idWorkOrder"),dateBegin,dateEnd)
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setWorkOrder(response.data.workOrder)
          setListSteps(response.data.success);
        }else if(response.data.empty){
          setOpenInfoAlert(true);
          setInfoAlertText(
            "info : "+response.data.empty
          );
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });


  }
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
   <br/>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetWorkOrdersHandler}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
        <div className="row mb-2">
            <div className="col-sm-12">
              {listSteps && (
                <DataTableStepsWorkOrder
                  listSteps={listSteps}
                  workOrder={workOrder}
                />
              )}
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </div>
    
  );

}
export default withLoader(WorkOrdersSteps)
